<button
  routerLink="../"
  class="bg-lighter-gray rounded-[12px] w-[48px] h-[48px] p-[12px]"
>
  <mat-icon
    class="cursor-pointer float-left arrow-left"
    svgIcon="arrow-left"
  ></mat-icon>
</button>
